import { useMutation } from '@tanstack/react-query';
import { axiosGlobalInstance } from 'api/axios/global';
import { routes } from 'api/routes';
import Cookies from 'js-cookie';
import { useAuthStore } from 'store/authStore';

const post = async <T>(values: T) => {
  return axiosGlobalInstance.post(routes['signin-github'], values);
};

const usePostSignInGithub = <T>() => {
  const { reset } = useAuthStore(state => state);

  return useMutation({
    mutationFn: post<T>,
    onSuccess: response => {
      reset();
      const token = response.data.token;
      Cookies.set('access_token', token);
    },
  });
};

export default usePostSignInGithub;
